module.exports = __webpack_public_path__ + "img/art-8.73c9ecb1.jpg";